<script>
	import PocketBase from 'pocketbase';
	const pb = new PocketBase('http://127.0.0.1:8090');

	/**
	 * Props
	 */
	export let title;
	export let gfId;
	export let pageId;
	export let programs;
	export let ip;
	console.log('programs = ', programs);

	/**
	 * Svelte/Store imports
	 */
	import { onMount } from 'svelte';
	import {
		step,
		setStep,
		formState,
		errors,
		clientSuccessValidation,
		clearClientSuccessValidation,
		clearError,
	} from './store.js';

	/**
	 * Modules
	 */
	import * as helpers from './helpers';
	import * as schema from './schema';

	/**
	 * Components
	 */
	import Confirmation from './components/Confirmation.svelte';
	import ConsumerNotice from './components/ConsumerNotice.svelte';
	import Disclaimer from './components/Disclaimer.svelte';
	import LeadSource from './components/LeadSource.svelte';

	/**
	 * Constants / Schema Defs - CSDL is Campus, Specialization, Degree Level
	 */
	const fieldBaseCSSClasses = 'field';
	const stepOneFieldsWithCDSL = [
		schema.modality,
		schema.program,
		schema.campusSpecializationDegreeLevel,
	];
	const stepOneFieldsWithoutCDSL = [schema.modality, schema.program];
	const stepTwoFields = [
		schema.firstName,
		schema.lastName,
		schema.phoneNumber,
		schema.zipCode,
		schema.emailAddress,
	];

	let stepOneFields = stepOneFieldsWithoutCDSL;

	function preValidation() {
		const schemas = {
			1: helpers.initSchema(stepOneFields),
			2: helpers.initSchema([...stepOneFields, ...stepTwoFields]),
		};

		const fields = {
			1: stepOneFields,
			2: [...stepOneFields, ...stepTwoFields],
		};

		clearClientSuccessValidation();
		let formFields, formSchema;
		console.log('$step = ', $step);

		formFields = fields[$step];
		formSchema = schemas[$step];

		helpers.validateStep($step, formFields, formSchema);
	}

	async function handleSubmit() {
		preValidation();
		if (Object.keys($clientSuccessValidation).length !== 0) {
			await helpers.submitGravityForm(
				gfId,
				$clientSuccessValidation.data,
				helpers.hiddenFields,
				activeProgramName,
				activeCampusName,
				pageId,
				pb,
			);
		}
	}

	/**
	 * UI State
	 */
	let activeModality = ''; // online / on-campus
	let activeProgramObject = {};
	let activeProgramName = '';
	let programOptGroups = []; // keys inside of programs[activeModality]
	let programPlaceholder = '';
	let csdlOptions = []; // campus / specialization / degree level
	let activeCSDL = '';
	let activeCampusName = '';
	let csdlPlaceholder = '';

	function handleModalityChange() {
		stepOneFields[1].value = '';
		if (activeProgramName) activeProgramName = '';
		if (stepOneFields[2]) stepOneFields[2].value = '';
		activeModality = stepOneFields[0].value;
		programOptGroups = programs[stepOneFields[0].value];
		programPlaceholder = `Which ${activeModality} program interests you?`;
		console.log('programOptGroups = ', programOptGroups);
	}

	function handleProgramChange() {
		if (stepOneFields[2]) stepOneFields[2].value = '';
		if (activeCampusName) activeCampusName = '';
		if (csdlOptions) csdlOptions = [];

		const selectedProgramValue = stepOneFields[1].value;
		const match = helpers.matchProgram(programOptGroups, selectedProgramValue);
		activeProgramObject = match.program;
		const program = match.program;
		const optGroup = match.optGroup;
		activeProgramName = program.text;
		console.log('program = ', program);
		console.log('optGroup = ', optGroup);

		// console.log("event = ", event);
		// console.log('selectedOption = ', selectedProgramValue);
		// console.log(
		// 	'helpers.matchProgram(programOptGroups, selectedProgramValue) = ',
		// 	helpers.matchProgram(programOptGroups, selectedProgramValue)
		// );

		if (activeModality === 'online') {
			optGroup === 'Nursing Specializations'
				? (activeCSDL = 'degree level')
				: (activeCSDL = 'specialization');
		} else {
			activeCSDL = 'campus';
		}

		if (program.children && program.children.length > 0) {
			csdlOptions = program.children;
			csdlPlaceholder = `Which ${activeCSDL} interests you?`;
			stepOneFields = stepOneFieldsWithCDSL;

			if (program.children.length === 1)
				stepOneFields[2].value = program.children[0].value;
		} else {
			csdlOptions = [];
			stepOneFields = stepOneFieldsWithoutCDSL;
		}
	}

	$: if (stepOneFields[1]?.value) activeProgramName = activeProgramObject.text;

	$: if (stepOneFields[2]?.value) {
		let campusId = stepOneFields[2].value.split(':')[1];
		console.log('campusId = ', campusId);

		if (campusId === 'ONL') {
			activeCampusName = 'Online';
		} else {
			campusId = parseInt(campusId);
			console.log('helpers.campuses = ', helpers.campuses);
			const campus = helpers.campuses.find((c) => c.id === campusId);
			console.log('campus = ', campus);

			campus ? (activeCampusName = campus.text) : (activeCampusName = '');
		}
		console.log('activeCampusName = ', activeCampusName);
	}

	onMount(() => {
		helpers.setConversionPageAndIP(ip);

		const pageMatchValues = helpers.checkPageIdMatch(programs, pageId.toString());
		console.log('pageMatchValues = ', pageMatchValues);
		if (pageMatchValues) {
			stepOneFields[0].value = pageMatchValues.modality;
			handleModalityChange();
			stepOneFields[1].value = pageMatchValues.program_value;
			handleProgramChange();
		}

		if (pageMatchValues?.child_value) {
			stepOneFields[2].value = pageMatchValues.child_value;
		}
	});

	let isDirty = false;
	function markDirty() {
		if (!isDirty) {
			isDirty = true;
			helpers.runDatalayerFormStartEvents(gfId);
		}
	}

	function backButtonHandler() {
		setStep(1);
		stepTwoFields.forEach((f) => {
			clearError(f);
			f.value = '';
		});
	}
</script>

<div class="rfi">
	{#if $formState === 'success'}
		<Confirmation />
	{:else}
		<h2>{title}</h2>
		<form on:submit|preventDefault={handleSubmit} on:input={markDirty}>
			{#if $step === 1}
				<!--          -->
				<!-- Modality -->
				<!--          -->
				<div
					class={$errors[stepOneFields[0].gf_input_name]
						? fieldBaseCSSClasses + ' ' + stepOneFields[0].id + ' has-error'
						: fieldBaseCSSClasses + ' ' + stepOneFields[0].id}
				>
					<label class={stepOneFields[0].type} for={stepOneFields[0].id}
						>{stepOneFields[0].label}</label
					>
					<div role="radiogroup" id={stepOneFields[0].id}>
						{#each stepOneFields[0].options as option, index}
							<div class="radio-option">
								<input
									type="radio"
									id={`${stepOneFields[0].id}-${index}`}
									name={stepOneFields[0].id}
									value={option.value}
									bind:group={stepOneFields[0].value}
									on:blur={() => helpers.handleBlur(stepOneFields[0])}
									on:change={() => handleModalityChange()}
								/>
								<label for={`${stepOneFields[0].id}-${index}`}
									>{option.text}</label
								>
							</div>
						{/each}
					</div>
					{#if $errors[stepOneFields[0].gf_input_name]}
						<span class="error"
							>{$errors[stepOneFields[0].gf_input_name]._errors[0]}</span
						>
					{/if}
				</div>
				<!--          -->
				<!-- Program  -->
				<!--          -->
				{#if stepOneFields[0].value !== ''}
					<div
						class={$errors[stepOneFields[1].gf_input_name]
							? fieldBaseCSSClasses + ' ' + stepOneFields[1].id + ' has-error'
							: fieldBaseCSSClasses + ' ' + stepOneFields[1].id}
					>
						<label class={stepOneFields[1].type} for={stepOneFields[1].id}
							>{stepOneFields[1].label}</label
						>
						<select
							class={stepOneFields[1].value === '' ? 'clean' : 'dirty'}
							id={stepOneFields[1].id}
							bind:value={stepOneFields[1].value}
							on:blur={() => helpers.handleBlur(stepOneFields[1])}
							on:change={handleProgramChange}
						>
							<option value="" disabled selected>{programPlaceholder}</option>
							{#each Object.entries(programOptGroups) as [key, value]}
								<optgroup label={key}>
									{#each value as option}
										<option value={option.value}>{option.title}</option>
									{/each}
								</optgroup>
							{/each}
						</select>

						{#if $errors[stepOneFields[1].gf_input_name]}
							<span class="error"
								>{$errors[stepOneFields[1].gf_input_name]._errors[0]}</span
							>
						{/if}
					</div>

					{#if stepOneFields[1].value === '10414:ONL'}
						<div class="rn-bsn-disclaimer">
							You must be a licensed registered nurse or have completed an
							Associate Degree in Nursing to apply for this program.
						</div>
					{/if}
				{/if}
				<!--                          -->
				<!-- Campus / Specialization  -->
				<!--                          -->
				{#if stepOneFields[1].value !== '' && csdlOptions.length > 0}
					<div
						class={$errors[stepOneFields[2].gf_input_name]
							? fieldBaseCSSClasses + ' ' + stepOneFields[2].id + ' has-error'
							: fieldBaseCSSClasses + ' ' + stepOneFields[2].id}
					>
						<label class={stepOneFields[2].type} for={stepOneFields[2].id}
							>{stepOneFields[2].label}</label
						>
						<select
							class={stepOneFields[2].value === '' ? 'clean' : 'dirty'}
							id={stepOneFields[2].id}
							bind:value={stepOneFields[2].value}
							on:blur={() => helpers.handleBlur(stepOneFields[2])}
						>
							<option value="" disabled selected>{csdlPlaceholder}</option>
							{#each csdlOptions as option}
								<option value={option.value}>{option.text}</option>
							{/each}
						</select>

						{#if $errors[stepOneFields[2].gf_input_name]}
							<span class="error"
								>{helpers.ucfirst(activeCSDL)}
								{$errors[stepOneFields[2].gf_input_name]._errors[0]}</span
							>
						{/if}
					</div>
				{/if}
			{:else}
				{#each stepTwoFields as field}
					<div
						class={$errors[field.gf_input_name]
							? fieldBaseCSSClasses + ' ' + field.class + ' has-error'
							: fieldBaseCSSClasses + ' ' + field.class}
					>
						<label class={field.type} for={field.id}>{field.label}</label>
						{#if field.type === 'text'}
							<input
								id={field.id}
								type="text"
								bind:value={field.value}
								placeholder={field.label}
								on:blur={() => helpers.handleBlur(field)}
							/>
						{:else if field.type === 'zipCode'}
							<input
								id={field.id}
								type="text"
								bind:value={field.value}
								placeholder={field.label}
								on:blur={() => helpers.handleBlur(field)}
								minlength="5"
								maxlength="5"
								pattern={'\\d{5}'}
							/>
						{:else if field.type === 'tel'}
							<input
								id={field.id}
								type="tel"
								maxlength="14"
								bind:value={field.value}
								placeholder={field.label}
								on:blur={() => helpers.handleBlur(field)}
								on:input={(e) =>
									(field.value = helpers.formatPhoneNumber(
										e.target.value,
										e.inputType
									))}
							/>
						{:else if field.type === 'email'}
							<input
								id={field.id}
								type="email"
								bind:value={field.value}
								placeholder={field.label}
								on:blur={() => helpers.handleBlur(field)}
							/>
						{/if}
						{#if $errors[field.gf_input_name]}
							<span class="error"
								>{$errors[field.gf_input_name]._errors[0]}</span
							>
						{/if}
					</div>
				{/each}
				<LeadSource
					on:mktSourceFromParams={helpers.setMktSource}
					on:mktSourceFromField={helpers.setMktSource}
				/>
			{/if}

			{#if $step === 2}
				<Disclaimer />
			{/if}

			<div class="button-container">
				<span style="width: 80px;">
					{#if $formState === 'loading'}
						<span class="rfi-loader"></span>
					{:else if $step === 2}
						<button
							type="button"
							class="button-reset"
							on:click={() => backButtonHandler()}>Go Back</button
						>
					{/if}
				</span>
				{#if $step === 1}
					<button class="button orange-fill" on:click={() => preValidation()}
						>Next</button
					>
				{:else}
					<button class="button orange-fill" type="submit">Submit</button>
				{/if}
				<span>Step {$step} of 2</span>
			</div>

			{#if $formState === 'error'}
				<!-- I believe this is for server side validation, or to display in the event of a server error -->
				<p style="margin-top: 12px;">
					An error occurred while submitting your request. Please email
					wcualumni@westcoastuniversity.edu if the issue persists.
				</p>
			{/if}
		</form>
		<ConsumerNotice />
	{/if}
</div>